import type { FC } from 'react';

import ColorOption from '../../fields/color_option/color_option';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['options', 'deselect'] as const;

const Field = formField(ColorOption, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type ColorOptionFieldWrapperProps = FieldWrapperProps<typeof Field>;

const ColorOptionFieldWrapper: FC<ColorOptionFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default ColorOptionFieldWrapper;
